// fileTypeFilter.js
export default function fileType(value) {
    if (!value) return '';

    const fileExtension = value.split('.').pop().toLowerCase();

    switch (fileExtension) {
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
            return 'md-image';
        case 'xls':
        case 'xlsx':
            return 'md-stats';
        case 'ppt':
        case 'pptx':
            return 'ios-videocam'
        default:
            return 'md-document';
    }
}